title: Openingstijd|Openingstijden
labels:
  until: tot
  pause: Pauze
  closed: Gesloten
  openingHours: Openingstijden
  free: Vrij
messages:
  useOpeningHoursEverywhere: Wil je deze tijden voor elke dag instellen?
  editOpeningHours: Stel per dag in of je open bent en wat de openingstijden zijn
actions:
  addBreak: Pauze toevoegen
